import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.ts";

Html.registerWidget('widget/minimap',{initDom})

var
  // list of location of family members
memberLocations = null,

// index of family member currently selected in list of member locations
selectedMemberIndex = 0,

// parent container
container: HTMLElement;

async function display(){
  const TPL = await import("../widget/minimap.mustache");
  var location = memberLocations[selectedMemberIndex % memberLocations.length];
  //this stuff is for sprint using full marker and not just marker_noplace
  if(location){
    location.locations = location;
  }
  Html.setHtml(container,TPL,{
    location: location,
    navigation: memberLocations.length>1
  });
}

Html.registerDom({
  minimap(delta){
    selectedMemberIndex += memberLocations.length + parseInt(delta,10);
    display();
  }
});
function initDom(obj: HTMLElement){
  container = obj;
  if(obj.offsetParent !== null) { // Vérifie si l'élément est visible
    ApiServer.locgetpositions2(function(data){
      memberLocations = data.filter(function(location){
        return location.mapURI!==null;
      });
      display();
    });

  }
}